import { render, staticRenderFns } from "./UserGroupe.vue?vue&type=template&id=47c478ae&scoped=true&"
import script from "./UserGroupe.js?vue&type=script&lang=js&"
export * from "./UserGroupe.js?vue&type=script&lang=js&"
import style0 from "./UserGroupe.vue?vue&type=style&index=0&id=47c478ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c478ae",
  null
  
)

export default component.exports